{
  "zod": {
    "invalid": "Значение не подходит",
    "invalidType": "Ожидается {{expected}}",
    "invalidValue": "Недопустимое значение",
    "invalidFormat": "Не соответствует формату {{format}}",
    "tooShort": "Короче {{min}} символов",
    "tooLong": "Длиннее {{max}} символов",
    "tooSmall": "Меньше {{min}}",
    "tooBig": "Больше {{max}}",
    "tooFew": "Нужно хотя бы {{min}}",
    "tooMany": "Не больше {{max}}",
    "notMultipleOf": "Должно быть кратно {{step}}",
    "unrecognizedKeys": "Лишние поля: {{keys}}"
  },
  "address": {
    "ipv4": "Адрес записывается как 192.168.0.10",
    "rangeOrder": "Начало диапазона должно быть не больше конца",
    "rangeTooBig": "В диапазоне не больше {{max}} адресов",
    "tooMany": "На узел не больше {{max}} дополнительных адресов",
    "duplicate": "Адрес {{address}} указан дважды",
    "sameAsNode": "{{address}} — основной адрес узла, добавлять его ещё раз незачем"
  },
  "name": {
    "required": "Название обязательно"
  },
  "secret": {
    "required": "Секрет обязателен",
    "tooLong": "Секрет длиннее {{max}} символов"
  },
  "password": {
    "tooShort": "Пароль короче {{min}} символов",
    "tooLong": "Пароль длиннее {{max}} символов"
  },
  "email": {
    "invalid": "Некорректный адрес электронной почты"
  },
  "user": {
    "roleRequired": "Нужна хотя бы одна роль"
  },
  "organization": {
    "slug": "Допустимы строчные латинские буквы, цифры и дефис между ними"
  },
  "credential": {
    "sshUserRequired": "Для SSH имя пользователя обязательно",
    "passphraseOnlyForKey": "Парольная фраза бывает только у приватного ключа"
  },
  "agent": {
    "platform": "Платформа записывается как linux/amd64",
    "version": "Версия записывается как 1.2.0",
    "fileName": "Имя файла: латиница, цифры, точка, дефис и подчёркивание",
    "checksum": "Контрольная сумма — 64 шестнадцатеричных знака"
  },
  "archive": {
    "speed": "Скорость воспроизведения: {{speeds}}",
    "rangeTooWide": "Интервал шире {{days}} суток за один запрос не берётся"
  },
  "range": {
    "startBeforeEnd": "Начало интервала должно быть раньше конца"
  },
  "camera": {
    "streamPathRequired": "Путь потока обязателен",
    "streamPathSlash": "Путь потока начинается со слэша",
    "streamPathChars": "Путь потока не может содержать пробелы, обратные слэши и решётку"
  },
  "recorder": {
    "templateRequired": "Шаблон пути обязателен для регистратора без API",
    "templateSlash": "Шаблон пути начинается со слэша",
    "templateChars": "Шаблон пути не может содержать пробелы, обратные слэши и решётку",
    "templateChannel": "В шаблоне нужно место для номера канала: {channel}"
  },
  "discovery": {
    "cidrFormat": "Подсеть записывается как 192.168.10.0/24",
    "cidrTooWide": "Подсеть должна быть не больше /{{prefix}} — иначе прогон растянется на часы"
  },
  "file": {
    "pathTooLong": "Путь длиннее {{max}} символов",
    "pathInvalid": "Недопустимый путь: разделитель — «/», переходы «..» и «.» запрещены, как и символы \\ < > \" | ? * и управляющие",
    "pathRequired": "Путь не указан",
    "newPathRequired": "Новый путь не указан",
    "transferId": "Некорректный идентификатор передачи"
  },
  "layout": {
    "nameRequired": "Название раскладки обязательно",
    "duplicateCell": "Две камеры в одной ячейке",
    "cellOutOfGrid": "Ячейка за пределами выбранной сетки"
  },
  "monitor": {
    "oid": "OID записывается цифрами через точку",
    "timeoutOverInterval": "Предел ожидания не должен превышать интервал проверки"
  },
  "node": {
    "color": "Ожидается цвет вида #rgb или #rrggbb",
    "selfLink": "Связь узла с самим собой не имеет смысла"
  },
  "notifications": {
    "emailInvalid": "Нужен корректный адрес",
    "recipientRequired": "Укажите хотя бы одного получателя",
    "chatIdRequired": "Укажите идентификатор чата",
    "urlInvalid": "Нужен полный адрес, включая http:// или https://",
    "urlScheme": "Поддерживаются только http и https",
    "headerName": "Имя заголовка: только видимые символы ASCII без пробелов",
    "headerValue": "Значение заголовка: только видимые символы ASCII"
  },
  "common": {
    "badId": "Некорректный идентификатор"
  },
  "cameras": {
    "ticketRequired": "Тикет обязателен"
  }
}
